export default __webpack_public_path__ + "static/media/large-purple-check-3x.b774c744.png";